import React, { useCallback, useState ,useEffect} from "react";
import { PieChart, Pie, Sector, Cell,ResponsiveContainer } from "recharts";
import '../../styles/los.css'
import { useDataContext } from "../../context/DataContext";



export default function Los({nodeId ,selectedScenarioLos}) {

    const [data, setDataJson] = useState([]);

    // Use DataContext for client-specific data (default or lavagna)
    const { losDataJson, dataLoaded } = useDataContext();

    useEffect(() => {
        if (dataLoaded && losDataJson && selectedScenarioLos) {
            const selectedScenario = losDataJson.scenario?.find(scenario => scenario.replicaAvg === selectedScenarioLos);
            if (selectedScenario) {
                setDataJson(selectedScenario.LosNodi);
                console.log('Los updated with scenario:', selectedScenario.LosNodi);
            } else {
                setDataJson({});
            }
        }
    }, [selectedScenarioLos, losDataJson, dataLoaded]);
    


const renderActiveShape  = (nodeId) => (props) => {
    const RADIAN = Math.PI / 180;
    const {
        cx,
        cy,
        midAngle,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        fill,
        payload,
    } = props;

    
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 15) * sin;
    const mx = cx + (outerRadius + 10) * cos;
    const my = cy + (outerRadius + 45) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 35;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";

    const selectedNode = data.find(node => node.idNodo === nodeId);
    const losNodeBgColor = selectedNode ? selectedNode.color : "#000";
    const losNodeText = selectedNode ? selectedNode.losNode : "";
    const losNodeTextFontSize = 60;
    const losNodeTextFill = "black";
    const circleRadius = 58;
    return (
        <>
            <circle
                cx={cx}
                cy={cy}
                r={circleRadius}
                fill={losNodeBgColor}
            />
            <text
                x="50%"
                y="54%"
                textAnchor="middle"
                fontSize={losNodeTextFontSize}
                fill={losNodeTextFill}
            >
                {losNodeText}
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={payload.color}
            />
            <Sector
                cx={cx}
                cy={cy}
                startAngle={startAngle}
                endAngle={endAngle}
                innerRadius={outerRadius + 6}
                outerRadius={outerRadius + 10}
                fill={payload.color}
            />
            <path
                d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
                stroke={payload.color}
                fill="none"
            />
            <circle cx={ex} cy={ey} r={5} fill={fill} stroke="none" />
            <text

                x={ex + (cos >= 0 ? 1 : -1) * 12}
                y={ey}
                textAnchor={textAnchor}
                fill="#333"
            >{payload.name}</text>
            <text
                x={ex + (cos >= 0 ? 1 : -1) * 12}
                y={ey}
                dy={15}
                textAnchor={textAnchor}
                fill="#999"
            >
                <tspan>{`Ritardo:${payload.delay},`}</tspan>
                <tspan x={ex + (cos >= 0 ? 1 : -1) * 12} dy={18}>{`Veicoli:${payload.count},`}</tspan>
                <tspan x={ex + (cos >= 0 ? 1 : -1) * 12} dy={18}>{payload.nomeVia}</tspan>
            </text>

        </>
    );
};

const filteredPieChartData = Array.isArray(data) ? data.reduce((acc, node) => {
    if (node.idNodo === nodeId) {
        acc.push(...Object.values(node.sezioni).map((section) => ({
            name: section.losSec || "Unnamed Section",
            ampiezza: section.ampiezza,
            color: section.color,
            delay: section.delaySec,
            count: section.count,
            nomeVia: section.nomeSec || "No Name"
        })));
    }
    return acc;
}, []) : [];

    const [activeIndex, setActiveIndex] = useState(0);
    const onPieEnter = useCallback(
        (_, index) => {
            setActiveIndex(index);
        },
        [setActiveIndex]
    );

    return (


            <div className="pie-container" style={{ height: "100%", width: "100%" }}>
               <div className="chart-title">
                <h2>Livello di Servizio </h2>
            </div>
                <div className="pie-chart" >
                
             
                <ResponsiveContainer width="100%" height="100%">
                <PieChart >

                        <Pie
                            activeIndex={activeIndex}
                            activeShape={renderActiveShape(nodeId)}
                            data={filteredPieChartData}
                            cx="50%" 
                            cy="50%" 
                            innerRadius={68}
                            outerRadius={85}
                            dataKey="ampiezza"
                            paddingAngle={2}
                            onMouseEnter={onPieEnter}
                            onClick={onPieEnter}
                            className="pie-cambia"
                        >
                            {filteredPieChartData.map((entry, index) => (
                                <Cell   key={`cell-${index}`} fill={entry.color} />
                            ))}
                        </Pie>
                    </PieChart>
                    </ResponsiveContainer>

                </div>
                <div className="legend">

                    <ul>
                        <li style={{ color: "#8FC975" }}  > A</li>
                        <li style={{ color: "#AED361" }} >B</li>
                        <li style={{ color: "#F6ED60" }}  >C</li>
                        <li style={{ color: "#FDB64E" }} >D</li>
                        <li style={{ color: "#EC1D23" }} >E</li>
                        <li style={{ color: "#C00000" }} >F</li>

                    </ul>
                </div>
            </div>
      

    );
}
